// Copyright Materialize, Inc. and contributors. All rights reserved.
//
// Use of this software is governed by the Business Source License
// included in the LICENSE file.
//
// As of the Change Date specified in that file, in accordance with
// the Business Source License, use of this software will be governed
// by the Apache License, Version 2.0.

// Global indexes
export const SELECT_MENU_Z_INDEX = 10;
export const MODAL_TOOLTIP_Z_INDEX = 1401;
export const DEVTOOL_BUTTONS_Z_INDEX = 2000;
export const STATUS_PAGE_WIDGET_Z_INDEX = 9999;

export const FIXED_TOP_BAR_Z_INDEX = 2;

export const WORKFLOW_GRAPH_CANVAS_Z_INDEX = 1;
export const WORKFLOW_GRAPH_NODE_Z_INDEX = 4;

export const ROLE_GRAPH_CANVAS_Z_INDEX = 1;
export const ROLE_GRAPH_NODE_Z_INDEX = 4;

// Used to prevent popovers from the compact navbar overflowing the main content
export const NAVBAR_Z_INDEX = 2;
export const MAIN_CONTENT_Z_INDEX = 1;
